<h2 matDialogTitle mat-dialog-draggable-title>
    {{'title.document_download_false' | translate}}
    <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
  <mat-divider></mat-divider>
  <mat-dialog-content>
    <div class="row">
      <div class="col-2 pr-0" style="text-align: center; padding-left: 0px !important; padding-top: 15px">
        <!--<em class="material-icons confirm-ico">
          info
        </em>-->
        <em class="fa fa-warning text-primary large"></em>
      </div>
      <div class="col-10 pl-0" *ngIf="isErrorServer">
        <p class="message" *ngIf="data.selectedFrom">
          {{ "document_download.template_from_error" | translate }}:
            <span class="font-weight-bold" >{{data.selectedFrom}}</span>
        </p>
        <p>{{data.message}}</p>
      </div>
      <div class="col-10 pl-0" *ngIf="!isErrorServer">
        <p [innerHTML]="errorMessage"></p>
      </div>
    </div>
  </mat-dialog-content>
  <mat-divider></mat-divider>
  <div mat-dialog-actions class="justify-content-center mt-2">
    <!--build icon, set default cancel-->
    <button mat-stroked-button color="primary" (click)="close()">
      <mat-icon class="mr-0">cancel</mat-icon>
      {{ "document_download.close" | translate }}
    </button>
  </div>